import { updateContact } from 'common/api/v1/contacts';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    SAVE_CONTACT,
    SAVE_CONTACT_FAILURE,
    SAVE_CONTACT_SUCCESS,
    UPDATE_ITEMS_SUCCESS,
} from '../actionTypes';
import { contactActions } from '../reducer';
import * as selectors from '../selectors';

export default (values) => (dispatch, getState) => {
    const state = getState();
    const data = selectors.getContactsData(state);

    if (!values.id) return;

    const newValues = {
        emails: JSON.stringify(values.emails),
        name: values.name,
        telephones: JSON.stringify(values.telephones),
    };
    dispatch(contactActions[SAVE_CONTACT]());

    updateContact(newValues, values.id)
        .then((response) => {
            dispatch(contactActions[SAVE_CONTACT_SUCCESS](response.data));
            const newItems = data.map((item) => {
                if (item.id === values.id) {
                    return values;
                }
                return item;
            });
            dispatch(contactActions[UPDATE_ITEMS_SUCCESS](newItems));
            showToast();
        })
        .catch((error) => {
            dispatch(
                contactActions[SAVE_CONTACT_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
